import authConfig from "./auth.config"
import NextAuth from "next-auth";

const { auth } = NextAuth(authConfig);

import { DEFAULT_LOGIN_REDIRECT, apiAuthPrefix, authRoutes, publicRoutes } from "@/routes"

export default auth((req) => {
    const { nextUrl } = req;
    const isLoggedin = !!req.auth;
    const isApiAuthRoute = nextUrl.pathname.startsWith(apiAuthPrefix);
    const isPublicRoute = publicRoutes.includes(nextUrl.pathname);
    const isAuthRoute = authRoutes.includes(nextUrl.pathname);

    if (isApiAuthRoute) {
        return;
    }
    if (isAuthRoute) {
        if (isLoggedin) {
            return Response.redirect(new URL(DEFAULT_LOGIN_REDIRECT, nextUrl))
        }
        return;
    }
    if (!isLoggedin && !isPublicRoute) {
        return Response.redirect(new URL("/auth/login", nextUrl))
    }
    return;
});

export const config = {
    // matcher:["/auth/login", "/auth/register"]
    matcher: ["/((?!api|_next/static|_next/image|favicon.ico).*)"],
}